// extracted by css-extract-rspack-plugin
export default {"ignoredIcon":"XKAbcHZWnX4pfY_r"};